export default __webpack_public_path__ + "static/media/ArrowUp.09c99972.svg";